import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import useLogin from "../hook/useLogin";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const { logout, municipio } = useLogin();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg fixed w-full z-10">
      <nav
        className="mx-auto flex container items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <a href="/" className="-m-1.5 p-1.5">
            <span className="sr-only">AMEXCID</span>
            <img className="h-8 w-auto" src="/favicon.png" alt="Logo" />
          </a>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          <span className="text-md text-claret-800 p-2">
            Bienvenido municipio de: <strong>{municipio}</strong>
          </span>
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <button
            onClick={() => {
              logout();
              setMobileMenuOpen(false);
              navigate("/login");
            }}
            className="text-sm font-semibold leading-6 text-claret-100 p-2 rounded-lg shadow-lg bg-claret-900"
          >
            Cerrar sesión <span aria-hidden="true">&rarr;</span>
          </button>
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                className="h-8 w-auto"
                src="/favicon.png"
                alt="Logo AMEXID"
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <span className="text-md text-claret-800 p-2">
                  Bienvenido municipio de: <strong>Tlaxcala</strong>
                </span>
              </div>
              <div className="py-6">
                <button
                  onClick={() => {
                    logout();
                    setMobileMenuOpen(false);
                    navigate("/login");
                  }}
                  className="-mx-3 w-full rounded-lg px-3 py-2.5 text-base font-semibold leading-7 bg-claret-900 text-claret-100"
                >
                  Cerrar sesión
                </button>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
}
